import React from 'react'
import styled, { withTheme } from 'styled-components'
import { array, bool } from 'prop-types'
import { Link } from 'gatsby'
import { Link as AnimateScroll } from 'react-scroll'
import { rem, lighten } from 'polished'
import { Flex } from 'rebass'
import { media } from '../../utils/style'
import OutboundLink from '../OutboundLink'

const FlexWrapper = styled(
  ({ theme, joined, offset, removemargin, ...rest }) => <Flex {...rest} />
)`
  position: relative;
  z-index: 1;
  color: ${(props) => props.theme.colors.white};
  flex-wrap: wrap;
  margin-bottom: 70px;
  ${media.MediumScreenUp`
  ${(props) => (props.offset ? 'transform: translateY(-50%);' : '')}
  flex-wrap: nowrap;
  `};
  ${media.LargeScreenUp`
    margin-bottom: 10vh;
  `};
  ${(props) => (props.removemargin ? 'margin-bottom: 0 !important;' : '')};
  ${(props) => (props.removemargin ? 'margin-top: 0 !important;' : '')};
  ${media.LargeScreenUp`
    &::before {
      content:'';
      position: absolute;
      z-index: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 95%;
      height: 100%;
      box-shadow:
        0 25px 25px 0px rgba(66,76,94,0.05),
        0 20px 20px 0 rgba(0,0,0,0.01);
    }
  `};
`

const BasicLink = styled(({ theme, duotone, to, animateScroll, ...rest }) => {
  if (animateScroll) {
    return <AnimateScroll smooth duration={500} to={to} {...rest} />
  } else if (to) {
    return <Link to={to} {...rest} />
  } else {
    return <OutboundLink {...rest} />
  }
})`
  position: relative;
  width: 100%;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  background-color: ${(props) => props.theme.colors.grey};
  text-decoration: none;
  text-transform: uppercase;
  font-weight: ${(props) => props.theme.weights[1]};
  font-size: ${(props) => rem(props.theme.fontSizes[2])};
  color: ${(props) => props.theme.colors.white};
  transition: background-color 0.8s ${(props) => props.theme.ease.ease_out_expo};
  padding: 15px;

  &:hover {
    color: ${(props) => props.theme.colors.white};
    background-color: ${(props) => lighten(0.12, props.theme.colors.grey)};
  }

  ${media.MediumScreenUp`
  border-right: 1px ${(props) => props.theme.colors.white} solid;
  `};

  span > span {
    display: inline-block;
    padding-left: 8px;
    font-weight: ${(props) => props.theme.weights[0]};
  }

  &:first-child {
    ${(props) =>
      props.duotone ? `background-color: ${props.theme.colors.blue};` : ''}
    &:hover {
      ${(props) =>
        props.duotone
          ? `background-color: ${lighten(0.12, props.theme.colors.blue)};`
          : ''}
    }
  }

  &:last-child {
    border-right: 0;
    ${(props) =>
      props.duotone
        ? `background-color: ${props.theme.colors.grey_light};`
        : ''}
    &:hover {
      ${(props) =>
        props.duotone
          ? `background-color: ${lighten(0.12, props.theme.colors.grey_light)};`
          : ''}
    }
  }

  border-bottom: 1px ${(props) => props.theme.colors.white} solid;
  ${media.LargeScreenUp`
  margin-bottom: 1px;
  border-bottom: 0;
  `};
`

class ContentBrandCtaBar extends React.PureComponent {
  render() {
    let itemMarkup = []
    this.props.items.forEach(({ to, href, label, ...other }, key) => {
      itemMarkup.push(
        <BasicLink
          href={href}
          to={to}
          key={`cbcblink:${key}`}
          duotone={this.props.duotone}
          {...other}
        >
          {label}
        </BasicLink>
      )
    })

    return (
      <FlexWrapper
        width={[12 / 12, null, 6 / 12]}
        joined={this.props.joined}
        removemargin={this.props.removemargin}
        offset={this.props.offset}
      >
        {itemMarkup}
      </FlexWrapper>
    )
  }
}

ContentBrandCtaBar.defaultProps = {
  items: [],
  joined: false,
  duotone: false,
  removemargin: false,
  offset: false
}
ContentBrandCtaBar.propTypes = {
  items: array,
  joined: bool,
  duotone: bool,
  removemargin: bool,
  offset: bool
}

export default withTheme(ContentBrandCtaBar)
